type EdicionConLink = { id: number | string; nombre_link?: string | null };

/** Normaliza el segmento de URL (minúsculas, guiones, sin acentos). */
export function normalizeEdicionNombreLink(raw: string): string {
  return raw
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function isEdicionNombreLinkValido(slug: string): boolean {
  if (!slug || slug.length < 2) return false;
  if (/^\d+$/.test(slug)) return false;
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug);
}

/** Segmento de ruta `/edicion/:segment` (slug o id numérico legacy). */
export function edicionCatalogoPathSegment(edicion: EdicionConLink): string {
  const slug = edicion.nombre_link?.trim();
  if (slug) return slug;
  return String(edicion.id);
}

export function edicionCatalogoPath(edicion: EdicionConLink, opts?: { app?: boolean }): string {
  const base = '/edicion';
  return `${base}/${encodeURIComponent(edicionCatalogoPathSegment(edicion))}`;
}
